import { render } from "./FieldSelector.vue?vue&type=template&id=1a5410e8&scoped=true"
import script from "./FieldSelector.vue?vue&type=script&lang=js"
export * from "./FieldSelector.vue?vue&type=script&lang=js"

import "./FieldSelector.vue?vue&type=style&index=0&id=1a5410e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5410e8"]])

export default __exports__